import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import NoBankImage from '../images/NoPackages.svg';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import {lobbyTabsEnum} from '../../CellcomAbroadLobbyBlock/cellcomAbroadVariables';
import { gaEvent } from '../../../../utilities/analytics/tracking';
import gaParams from '../../../../utilities/analytics/constants';

const NoBankPackages = ({setActiveLobbyTab, context, currPath, iContent}) => {
  return (
    <div className='NoBankPackagesWarning'>
      <Image src={NoBankImage} />
      <div>
        <p className='m-0'>
          <b>למנוי זה אין חבילות לחו"ל</b>
        </p>
        <p>המנעו משימוש הנייד בחו"ל שלא תקבלו חיובים גבוהים</p>
      </div>
      <BtnSubmit
        onclick={() => {
          setActiveLobbyTab(lobbyTabsEnum.PRIVATE);
          gaEvent(gaParams.ABROAD_DATAUSAGES_BUYPACKAGECLICK.category,gaParams.ABROAD_DATAUSAGES_BUYPACKAGECLICK.eventType,gaParams.ABROAD_DATAUSAGES_BUYPACKAGECLICK.eventParams);
          if (iContent.lobbyPage.value == null) {
            context.navigateTo(currPath);
          } else {
            context.navigateTo(iContent.lobbyPage.value.url);
          }
        }}
        text='רכוש חבילה'
        isDisplayArrows={true}
      />
    </div>
  );
};

export default NoBankPackages;
